import { useEffect, useMemo } from 'react';
import { createModulesContainer } from './dashboardContainer.hook';
import { useDispatch, useSelector } from 'react-redux';
import { useFlag } from 'hook/flag.hook';
import {
  loadDashboardDependencies,
  getPaymentHistoryContainer,
  getCreditUsageContainer,
  getAccountMixContainer,
  getCreditAgeContainer,
  getCreditInquiriesContainer,
  resetPaymentHistoryContainerData,
  resetCreditUsageContainerData,
  resetAccountMixContainerData,
  resetCreditAgeContainerData,
  resetCreditInquiriesContainerData,
  load1b3bFactorDetails,
  select1b3bBureau,
  loadPotentialCreditProfileContainer,
  resetPotentialCreditProfileContainerData,
  loadFactorContainer,
  setSelectedFactorToToday,
} from 'actions/dashboard.actions';
import { BUREAU_ENUMS, FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { useConfig } from 'hook/config.hook';
import { useEventBatching } from 'hook/event.hook';
import { getCreditReport } from 'actions/creditReports.actions';
import { urlSearchParams } from 'helpers/common';
import {
  getPersonalLoanPreApprovals,
  retrievePrequalFormData,
} from 'partial/OfferManager/modules/PersonalLoanMarketplaceModule/PersonalLoanMarketplaceModule.actions';
import { isPlus } from 'helpers/userHelper';
import { isEmpty } from 'helpers/string.helper';

export const useDashboardPage = props => {
  const {
    userInfo,
    creditInfo,
    location,
    history,
    isPotentialScoreFactorModule,
  } = props;
  const {
    PAYMENT_HISTORY,
    ACCOUNT_MIX,
    CREDIT_AGE,
    CREDIT_INQUIRIES,
    CREDIT_USAGE,
    POTENTIAL_CREDIT_PROFILE,
  } = FACTOR_ENUMS;

  const urlSearch = urlSearchParams(location?.search, 'factor');

  const dashboardPageFlag = useFlag('dashboard_page', {
    defaultConfig: {
      excludeEngagementOffers: true,
      showEngagementModule: false,
      freeSingupBanner: {
        textSignUpBanner: 'Check out your',
        linkTextSignUpBanner: 'recommended action plan',
        linkSignUpBanner: '/goals',
        clickTypeSignUpBanner: 'Actions Top Module',
        showSignUpBanner: true,
      },
    },
  });
  const showCapitalOneOffersFlag = useFlag(
    'capital_one_prescreen_offer_module',
  );
  const availableForYouWebFlag = useFlag('available_for_you_web', {
    defaultConfig: {
      showModuleAvailableForYou: false,
    },
  });
  const showCapitalOneOffers =
    showCapitalOneOffersFlag?.config?.show_capone_pre_screen;
  const showModuleAvailableForYou =
    availableForYouWebFlag?.config?.showModuleAvailableForYou;
  const isFreeSignUpBannerShow = dashboardPageFlag?.config?.freeSingupBanner;
  const excludeEngagementOffers =
    dashboardPageFlag?.config?.excludeEngagementOffers;

  const plusBannerOverviewWebFlag = useFlag('plusbanneroverview_web');
  const plusBannerOverviewWebConfig = plusBannerOverviewWebFlag?.config ?? {};

  const removeSesamePickOffersWebFlag = useFlag('removesesamepickoffers_web');

  const removeSesamePickOffers =
    removeSesamePickOffersWebFlag?.config?.removeSesamePickOffers;

  const plUpsellModuleTargetingFlag = useFlag('pl_upsell_module_targeting_web');
  const plUpsellModuleTargetingQueryParams =
    plUpsellModuleTargetingFlag?.config?.webQueryParams;

  const plPrequalOfferFlag = useFlag('pl_prequal_offer_web');
  const plPrequalOfferQueryParams = plPrequalOfferFlag?.config?.webQueryParams;

  const isPlusUser = isPlus(userInfo);

  const dispatch = useDispatch();
  const {
    selectedFactor,
    selectedBureau,
    profileContainer,
    profileContainerLoading,
    profileContainerError,
    todayContainer,
    todayContainerLoading,
    todayContainerError,
    paymentHistoryContainer,
    paymentHistoryContainerLoading,
    creditUsageContainer,
    creditUsageContainerLoading,
    accountMixContainer,
    accountMixContainerLoading,
    creditAgeContainer,
    creditAgeContainerLoading,
    creditInquiriesContainer,
    creditInquiriesContainerLoading,
    sesameCashAccount,
    potentialCreditProfileContainer,
    potentialCreditProfileContainerLoading,
    potentialCreditProfileContainerError,
    prequalResultData,
  } = useSelector(state => ({
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
    selectedBureau: state?.score1b3bFactorDial?.bureau?.selectedBureau,
    profileContainer: state?.profileContainer?.profileContainer,
    todayContainer: state?.todayContainer?.todayContainer,
    todayContainerLoading: state?.todayContainer?.containerLoading,
    profileContainerLoading: state?.profileContainer?.containerLoading,
    profileContainerError: state?.profileContainer?.containerError,
    todayContainerError: state?.todayContainer?.containerError,
    paymentHistoryContainer:
      state?.paymentHistoryContainer?.paymentHistoryContainer,
    paymentHistoryContainerLoading:
      state?.paymentHistoryContainer?.containerLoading,
    creditUsageContainer: state?.creditUsageContainer?.creditUsageContainer,
    creditUsageContainerLoading: state?.creditUsageContainer?.containerLoading,
    accountMixContainer: state?.accountMixContainer?.accountMixContainer,
    accountMixContainerLoading: state?.accountMixContainer?.containerLoading,
    creditAgeContainer: state?.creditAgeContainer?.creditAgeContainer,
    creditAgeContainerLoading: state?.creditAgeContainer?.containerLoading,
    creditInquiriesContainer:
      state?.creditInquiriesContainer?.creditInquiriesContainer,
    creditInquiriesContainerLoading:
      state?.creditInquiriesContainer?.containerLoading,
    sesameCashAccount: state?.sesameCash?.cashAccount,
    potentialCreditProfileContainer:
      state?.potentialCreditProfileContainer?.potentialCreditProfileContainer,
    potentialCreditProfileContainerLoading:
      state?.potentialCreditProfileContainer?.containerLoading,
    potentialCreditProfileContainerError:
      state?.potentialCreditProfileContainer?.containerError,
    prequalResultData: state?.datacache?.PL_PREQUAL_RESULT_KEY,
  }));

  const loadTodayDashboard = () => {
    if (
      !profileContainer &&
      !todayContainer &&
      !todayContainerLoading &&
      !profileContainerLoading &&
      !todayContainerError &&
      !profileContainerError
    ) {
      dispatch(
        loadDashboardDependencies({
          isPlusUser,
          plUpsellModuleTargetingQueryParams,
          plPrequalOfferQueryParams,
        }),
      );
    }
  };

  const resetPotentialCreditProfileDashboard = () => {
    dispatch(resetPotentialCreditProfileContainerData());
  };

  const onBureauSelection = newSelectedBureau => {
    if (selectedBureau && newSelectedBureau !== selectedBureau) {
      dispatch(resetPaymentHistoryContainerData());
      dispatch(resetCreditUsageContainerData());
      dispatch(resetAccountMixContainerData());
      dispatch(resetCreditAgeContainerData());
      dispatch(resetCreditInquiriesContainerData());
      switch (selectedFactor) {
        case PAYMENT_HISTORY:
          dispatch(getPaymentHistoryContainer({ bureau: newSelectedBureau }));
          break;
        case CREDIT_USAGE:
          dispatch(getCreditUsageContainer({ bureau: newSelectedBureau }));
          break;
        case ACCOUNT_MIX:
          dispatch(getAccountMixContainer({ bureau: newSelectedBureau }));
          break;
        case CREDIT_AGE:
          dispatch(getCreditAgeContainer({ bureau: newSelectedBureau }));
          break;
        case CREDIT_INQUIRIES:
          dispatch(getCreditInquiriesContainer({ bureau: newSelectedBureau }));
          break;
        default:
          break;
      }
      dispatch(
        load1b3bFactorDetails({
          selectedFactor: selectedFactor,
          selectedBureau: newSelectedBureau,
        }),
      );
      dispatch(select1b3bBureau({ selectedBureau: newSelectedBureau }));
    }
  };

  useEffect(() => {
    if (
      userInfo &&
      creditInfo &&
      !selectedBureau &&
      !todayContainer &&
      !profileContainer
    ) {
      dispatch(select1b3bBureau({ selectedBureau: BUREAU_ENUMS.TRANS_UNION }));
      loadTodayDashboard();
      dispatch(getCreditReport());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userInfo,
    todayContainerLoading,
    profileContainerLoading,
    profileContainer,
    todayContainer,
    todayContainerError,
    profileContainerError,
    selectedBureau,
    creditInfo,
  ]);

  useEffect(() => {
    if (
      !prequalResultData ||
      (!prequalResultData?.prequalResultDataLoading && userInfo)
    ) {
      if (!prequalResultData?.formInput && !prequalResultData?.isEmptyForm) {
        dispatch(retrievePrequalFormData());
      } else if (!prequalResultData?.result?.offers) {
        dispatch(getPersonalLoanPreApprovals(userInfo, prequalResultData));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, prequalResultData]);

  const goToFactorPage = factor => {
    const searchParams = new URLSearchParams(location?.search);
    searchParams.set('factor', factor);
    history.push(`?${searchParams}`);
  };

  useEffect(() => {
    if (todayContainer && profileContainer) {
      if (urlSearch) {
        switch (urlSearch) {
          case PAYMENT_HISTORY:
            dispatch(loadFactorContainer(PAYMENT_HISTORY, selectedBureau));
            break;
          case CREDIT_USAGE:
            dispatch(loadFactorContainer(CREDIT_USAGE, selectedBureau));
            break;
          case CREDIT_AGE:
            dispatch(loadFactorContainer(CREDIT_AGE, selectedBureau));
            break;
          case ACCOUNT_MIX:
            dispatch(loadFactorContainer(ACCOUNT_MIX, selectedBureau));
            break;
          case CREDIT_INQUIRIES:
            dispatch(loadFactorContainer(CREDIT_INQUIRIES, selectedBureau));
            break;
          case POTENTIAL_CREDIT_PROFILE:
            dispatch(loadPotentialCreditProfileContainer());
            break;
          default:
            history.push('dashboard');
            break;
        }
      } else {
        if (!isPotentialScoreFactorModule) {
          dispatch(setSelectedFactorToToday());
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileContainer, selectedBureau, todayContainer, urlSearch]);

  const { config } = useConfig();
  const { factorModules, isFactorContainerLoading, todayContainerModules } =
    useMemo(
      _ => {
        const deps = {
          selectedFactor: selectedFactor,
          profileContainer,
          profileContainerLoading,
          todayContainer,
          todayContainerLoading,
          paymentHistoryContainer,
          paymentHistoryContainerLoading,
          creditAgeContainer,
          creditAgeContainerLoading,
          accountMixContainer,
          accountMixContainerLoading,
          creditUsageContainer,
          creditUsageContainerLoading,
          creditInquiriesContainer,
          creditInquiriesContainerLoading,
          potentialCreditProfileContainer,
          potentialCreditProfileContainerLoading,
          config,
          sesameCashAccount,
          creditInfo,
          userInfo,
          excludeEngagementOffers,
          plusBannerOverviewWebConfig,
          showCapitalOneOffers,
          removeSesamePickOffers,
          showModuleAvailableForYou,
        };
        return createModulesContainer(deps, config);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        selectedFactor,
        todayContainer,
        todayContainerLoading,
        profileContainer,
        profileContainerLoading,
        paymentHistoryContainer,
        paymentHistoryContainerLoading,
        creditAgeContainer,
        creditAgeContainerLoading,
        accountMixContainer,
        accountMixContainerLoading,
        creditUsageContainer,
        creditUsageContainerLoading,
        creditInquiriesContainer,
        creditInquiriesContainerLoading,
        userInfo,
        creditInfo,
        potentialCreditProfileContainer,
        potentialCreditProfileContainerLoading,
        plusBannerOverviewWebConfig,
      ],
    );
  useEventBatching(false);
  const staticModulesThree = todayContainerModules
    ? { modules: todayContainerModules }
    : null;
  const staticModules = factorModules ? { modules: factorModules } : null;
  return {
    staticModules,
    staticModulesThree,
    profileContainer,
    potentialCreditProfileContainer,
    todayContainer,
    profileContainerLoading,
    potentialCreditProfileContainerLoading,
    todayContainerLoading,
    loadTodayDashboard,
    onBureauSelection,
    isFactorContainerLoading,
    selectedFactor,
    selectedBureau,
    isFreeSignUpBannerShow,
    potentialCreditProfileContainerError,
    resetPotentialCreditProfileDashboard,
    goToFactorPage,
    todayContainerError,
    profileContainerError,
    showModuleAvailableForYou:
      showModuleAvailableForYou &&
      !isEmpty(
        todayContainerModules?.filter(
          mod => mod?.module === 'AVAILABLE_FOR_YOU',
        ),
      ),
  };
};
